import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "../../../hooks";
import { WheelOfFortuneMode } from "../../../redux/games/wheel-of-fortune";
import { wheelOfFortuneGetInfo } from "../../../redux/games/wheel-of-fortune/get-info.handler";
import styles from './FreeSpinsBlock.module.scss';

export const FreeSpinsBlock = () => {
    const [timeLeft, setTimeLeft] = useState<string>('');

    const dispatch = useDispatch();
    const { nextResetTime, freeSpinsCount, mode: currentMode } = useSelector(store => store.games.wheelOfFortune);

    useEffect(() => {
        if (freeSpinsCount > 0 || currentMode !== WheelOfFortuneMode.Free) {
            setTimeLeft('');
            return;
        }

        const updateTimer = () => {
            const now = Date.now();
            const resetTimeMs = nextResetTime * 1000;
            
            let diff = resetTimeMs - now;
            
            if (diff <= 0) {
                setTimeLeft('00:00:00');
                dispatch(wheelOfFortuneGetInfo());
                return;
            }
            
            const hours = Math.floor(diff / (1000 * 60 * 60));
            diff %= 1000 * 60 * 60;
            const minutes = Math.floor(diff / (1000 * 60));
            diff %= 1000 * 60;
            const seconds = Math.floor(diff / 1000);
            
            setTimeLeft(
                `${hours.toString().padStart(2, '0')}:` +
                `${minutes.toString().padStart(2, '0')}:` +
                `${seconds.toString().padStart(2, '0')}`
            );
        };

        updateTimer();
        const timerId = setInterval(updateTimer, 1000);
        
        return () => clearInterval(timerId);
    }, [freeSpinsCount, currentMode, nextResetTime, dispatch]);

    const getFreeSpins = () => {        
        let content = '';
        if (currentMode === WheelOfFortuneMode.Free) {
            content = freeSpinsCount > 0
                ? `Осталось бесплатных попыток: ${freeSpinsCount}`
                : `Новые беслатные попытки через: ${timeLeft}`;
        }

        return <span className={styles.freeSpins}>{content}</span>;
    }

    return getFreeSpins();
}